import { Component, Input } from '@angular/core';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { StorageSessionService } from '../../../../core/storage/services/storage.session.service';
import { AnalyticsCoreURLService } from '../../../analytics-core/services/analytics-core.url.service';
import { ModalService } from '../../../shared/directives/modal/modal.service';
import { Router } from '@angular/router';
import { PrintableReportComponent } from '../printable-report/printable-report.component';
import { AnalyticsMixpanelService } from '../../../analytics/services/analytics.mixpanel.service';

@Component({
	selector: 'app-printable-report-r1',
	templateUrl: './printable-report-r1.component.html',
	styleUrls: ['./printable-report-r1.component.css']
})
export class PrintableReportComponentR1 extends PrintableReportComponent {
	public isR2: boolean;
	public isR101: boolean = false;
	public isR104: boolean = false;
	@Input() overviewprintablereport: string = '';
	constructor(
		protected modalService: ModalService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected storageSessionService: StorageSessionService,
		protected analyticsCoreURLService: AnalyticsCoreURLService,
		protected router: Router,
		protected analyticsMixpanelService: AnalyticsMixpanelService
	) {
		super(
			modalService,
			analyticsDataModel,
			storageSessionService,
			analyticsCoreURLService,
			router,
			analyticsMixpanelService
		);
	}
	ngOnInit() {
		this.isR2 = this.analyticsDataModel.config.version === 'R2' ? true : false;
		this.isR101 = this.analyticsDataModel.config.partner.directoryName === 'default-r101' ? true : false;
		this.isR104 = this.analyticsDataModel.config.partner.directoryName === 'default-r104' ? true : false;
		super.ngOnInit();
	}
	closeModal() {
		this.modalService.close('productsModal');
	}
}
